/**
 * /settings — multi-tenant SaaS console.
 *
 * Identity comes from the dashboard-shell auth context; the loader fetches
 * just the team + org payloads in parallel.
 */

import { useLoaderData } from "react-router-dom";

import { PageHeader } from "@/components/page-header";
import { SettingsTabs } from "@/features/settings/settings-tabs";
import { api } from "@/lib/api";
import type { OrgResponse, TeamResponse } from "@/lib/types";

interface SettingsLoaderData {
  team: TeamResponse;
  org: OrgResponse;
}

export async function settingsLoader(): Promise<SettingsLoaderData> {
  const [team, org] = await Promise.all([
    api<TeamResponse>("/teams/current"),
    api<OrgResponse>("/orgs/current"),
  ]);
  return { team, org };
}

export default function SettingsRoute() {
  const data = useLoaderData() as SettingsLoaderData;
  return (
    <section className="space-y-4">
      <PageHeader
        eyebrow="workspace"
        title="Settings"
        subtitle="Manage your profile, team, organization, API keys, and usage."
      />
      <SettingsTabs initial={data} />
    </section>
  );
}
